module.exports = __webpack_public_path__ + "media/react/mcat/pages/dashboard/assets/single_check-493ba5b9bbd5edb93c024a723e9dcc7a.png";